import {
  Plane,
  Wheat,
  ShoppingBag,
  Truck,
  Hammer,
  Building2, // Cambiar Building por Building2
  Construction,
  MapPin, // Cambiar LandPlot por MapPin
  Cpu,
  HeartHandshake, // Cambiar HeartPulse por HeartHandshake
  Warehouse,
  Fuel,
  TestTube2, // Cambiar FlaskConical por TestTube2
  PaintBucket, // Cambiar Paintbrush2 por PaintBucket
  Package2, // Cambiar Boxes por Package2
  Factory,
  Wrench,
  FileText, // Cambiar Newspaper por FileText
  CircleSlash, // Cambiar Ban por CircleSlash
  Ship // Cambiar Sailboat por Ship
} from 'lucide-react';

export const iconMap: { [key: string]: React.ComponentType<any> } = {
  AERONAUTICA: Plane,
  AGRICOLA: Wheat,
  ALIMENTICIA: ShoppingBag,
  AUTOMOTRIZ: Truck,
  CARPINTERIA: Hammer,
  CEMENTERA: Building2, // Cambiar Building por Building2
  CONSTRUCCION: Construction,
  VIALIDAD: MapPin, // Cambiar LandPlot por MapPin
  ELECTRICA: Cpu,
  ELECTRONICA: Cpu,
  FARMACEUTICA: HeartHandshake, // Cambiar HeartPulse por HeartHandshake
  FERRETERIA: Hammer,
  FRIGORIFICA: Warehouse,
  GAS: Fuel,
  LABORATORIO: TestTube2, // Cambiar FlaskConical por TestTube2
  LIMPIEZA: PaintBucket, // Cambiar Paintbrush2 por PaintBucket
  LOGISTICA: Package2, // Cambiar Boxes por Package2
  MANUFACTURA: Factory,
  METALMECANICA: Wrench,
  METALURGICA: Factory,
  MINERA: Construction,
  PAPELERA: FileText, // Cambiar Newspaper por FileText
  PETROLEO: Fuel,
  PETROLERA: Fuel,
  QUIMICA: TestTube2, // Cambiar FlaskConical por TestTube2
  SALUD: HeartHandshake, // Cambiar HeartPulse por HeartHandshake
  SIDERURGICA: Factory,
  SOLDADURA: Wrench,
  TABACALERA: CircleSlash, // Cambiar Ban por CircleSlash
  TRANSPORTE: Truck,
};

export const industries = [
    {
        name: 'AGRICOLA',
        description: 'Equipos de protección para la industria agrícola, incluyendo guantes, protección respiratoria y ropa especializada.',
        image: 'https://images.unsplash.com/photo-1234/agricola.jpg',
    },
    {
        name: 'ALIMENTICIA',
        description: 'Equipos de protección específicos para la industria alimentaria, incluyendo vestimenta especial y elementos de higiene industrial.',
        image: 'https://images.unsplash.com/photo-1234/alimenticia.jpg',
    },
    {
        name: 'CONSTRUCCION',
        description: 'Equipamiento completo de seguridad para obras, incluyendo protección contra caídas, cascos, calzado de seguridad y equipos de protección personal.',
        image: 'https://images.unsplash.com/photo-1234/construccion.jpg',
    },
    {
        name: 'LOGISTICA',
        description: 'Equipos de seguridad para operaciones logísticas y de almacén, incluyendo fajas, guantes y calzado especializado.',
        image: 'https://images.unsplash.com/photo-1234/logistica.jpg',
    },
    {
        name: 'MANUFACTURA',
        description: 'Equipamiento de seguridad para manufactura general, incluyendo protección de manos, respiratoria y corporal para entornos industriales.',
        image: 'https://images.unsplash.com/photo-1234/manufactura.jpg',
    },
    {
        name: 'METALMECANICA',
        description: 'Equipos de protección para trabajos de metalurgia y mecánica, incluyendo protección facial, guantes resistentes y delantales.',
        image: 'https://images.unsplash.com/photo-1234/metalmecanica.jpg',
    },
    {
        name: 'MINERIA',
        description: 'Equipos de protección para minería, incluyendo protección respiratoria, visual, auditiva y equipamiento de altura.',
        image: 'https://images.unsplash.com/photo-1234/mineria.jpg',
    },
    {
        name: 'PETROLERA',
        description: 'Equipamiento especializado para la industria petrolera, incluyendo trajes ignífugos, respiradores y cascos de seguridad.',
        image: 'https://images.unsplash.com/photo-1234/petrolera.jpg',
    },
    {
        name: 'QUIMICA',
        description: 'Equipos de protección para la industria química, incluyendo trajes de protección, respiradores y guantes resistentes a químicos.',
        image: 'https://images.unsplash.com/photo-1234/quimica.jpg',
    },
    {
        name: 'SALUD',
        description: 'Equipamiento de protección para profesionales de la salud, incluyendo mascarillas, guantes, batas y protección ocular.',
        image: 'https://images.unsplash.com/photo-1234/salud.jpg',
    },
    // Industrias adicionales (comentadas pero mantenidas para referencia futura)
    /*
    {
        name: 'AERONAUTICA',
        description: 'Soluciones especializadas de seguridad para mantenimiento de aeronaves, hangares y operaciones aeroportuarias.',
        image: 'https://images.unsplash.com/photo-1570710891163-6d3b5c47248b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'AUTOMOTRIZ',
        description: 'Equipamiento de seguridad para la industria automotriz.',
        image: '',
    },
    {
        name: 'AVICOLA',
        description: 'Equipos de protección para la industria avícola.',
        image: '',
    },
    {
        name: 'CARPINTERIA',
        description: 'Equipos de protección específicos para trabajo en madera, control de polvo y manejo de maquinaria.',
        image: 'https://images.unsplash.com/photo-1622398925373-3f91b1e275f5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'CEMENTERA',
        description: 'Soluciones de seguridad para plantas de cemento, protección respiratoria y control de particulados.',
        image: 'https://images.unsplash.com/photo-1617791160505-6f00504e3519?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'ELECTRONICA',
        description: 'Equipamiento antiestático y de precisión para manufactura de componentes electrónicos.',
        image: 'https://images.unsplash.com/photo-1588508065123-287b28e013da?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'FARMACEUTICA',
        description: 'Protección especializada para laboratorios farmacéuticos y áreas estériles.',
        image: 'https://images.unsplash.com/photo-1563213126-a4273aed2016?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'FERRETERIA',
        description: 'Equipamiento de seguridad general.',
        image: '',
    },
    {
        name: 'FRIGORIFICA',
        description: 'Equipos de protección para trabajo en frío.',
        image: '',
    },
    {
        name: 'GAS',
        description: 'Equipamiento especializado para manejo de gases industriales y plantas de procesamiento.',
        image: 'https://images.unsplash.com/photo-1563089145-599997674d42?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'LIMPIEZA',
        description: 'Protección química y biológica para servicios de limpieza industrial.',
        image: 'https://images.unsplash.com/photo-1584784670536-8a1b7c4c7e1a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'METALURGICA',
        description: 'Equipamiento de seguridad para metalurgia.',
        image: '',
    },
    {
        name: 'NAVIERA',
        description: 'Equipamiento de seguridad para industria naval.',
        image: '',
    },
    {
        name: 'PESQUERA',
        description: 'Equipos de protección para industria pesquera.',
        image: '',
    },
    {
        name: 'PETROQUIMICA',
        description: 'Equipos de protección para industria petroquímica.',
        image: '',
    },
    {
        name: 'SALUD',
        description: 'Elementos de protección sanitaria y bioseguridad para personal médico.',
        image: 'https://images.unsplash.com/photo-1583947215259-38e31be8751f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'SIDERURGICA',
        description: 'Equipamiento de alta resistencia para trabajo con metales a altas temperaturas.',
        image: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80',
    },
    {
        name: 'SOLDADURA',
        description: 'Equipamiento de seguridad para soldadura.',
        image: '',
    },
    {
        name: 'TABACALERA',
        description: 'Equipos de protección para industria tabacalera.',
        image: '',
    },
    {
        name: 'TRANSPORTE',
        description: 'Elementos de seguridad para transporte de carga y logística.',
        image: '',
    },
    {
        name: 'VIALIDAD',
        description: 'Equipos de protección para trabajo vial.',
        image: '',
    }
    */
];
